<template>
<Modal 
    :id="'cmp_bookings_booking_add_artist'"
    @cancelled="onCancelClick"  
>
    <template slot="header">
        <template> {{$t(header)}} </template>
        
    </template>
    <template slot="body">
 
        
            <TextField
              class="m1"
            
              type="date"
              :id="'accounted_date'"
              v-bind="textFieldConfig"
              :value="accounted_date"
              :placeholder="$dft.capHead($t('accounted_date'))"
              @valuechanged="onTextFieldValueChange"
            
            
            ></TextField>


     </template>
    <template slot="options">
        <button class="dt-button s7 " @click="onCancelClick">{{$t('cancel')}}</button>
        <button   class="dt-button s7 v1" @click="onOKClick">OK</button>
        
    </template>
</Modal>
  
  
</template>

<script>
import Modal from '../../../../dt-plugins/modal/modal';

import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";


import ModalContainer from "@dtplugins/modal/modal-container";
import { format } from 'date-fns';
import { OrderService } from '../../services/order.service';
import { invoiceListLDTRoutes } from '../../../accounting/router/routes';
import { SupplierOrdersService } from '../../services/supplier.order.service';





export default {
  components: {
    
    Modal,
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,
   
    //AdvanceSearch,
   
  },
  mounted:async  function () {
    // await recoupableService.autoFetchForAllContracts();
        
  },
  data: function () {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        immediateValidation: false,
      },
       accounted_date:format(new Date(),'YYYY-MM-DD'),
    
    };
  },
   mixins: [],

  computed: {
    supplier_order_id:function(){
      return this.$route.query.supplier_order_id;
    },

    header:function(){
      return this.$route.query.header;
    },
    action:function(){
      return this.$route.query.action;
    },
    
  },
  methods: { 
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },

    
     onTextFieldValueChange: function (name, value) {    
      this[name]=value;

      // this.selectedProductMedia = {
      //   ...this.selectedProductMedia,
      //   [name]: value,
      // };
    },

    onOKClick:async function(){

      //await SupplierOrdersService.finishOrder({ supplier_order_id:this.supplier_order_id ,accounted_date:this.accounted_date ,action:this.action });

      this.$emit('finishOrder',{ supplier_order_id:this.supplier_order_id ,accounted_date:this.accounted_date ,action:this.action });
    }
  
  },
};
</script>

<style lang="scss">
.cmp-catalog-releases-releases_list {
  .dt-page--body {
    --offset: 190px;
  }
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  //   .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;
     
  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>